import React from 'react';
import { cn } from '@/utils';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const Skeleton: React.FC<SkeletonProps> = ({ className, ...props }) => {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-gray-200 dark:bg-gray-800",
        className
      )}
      {...props}
    />
  );
};

// Specific skeleton components for different UI elements
const SkeletonText: React.FC<{ lines?: number; className?: string }> = ({
  lines = 1,
  className
}) => (
  <div className={cn("space-y-2", className)}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton key={i} className="h-4 w-full" />
    ))}
  </div>
);

const SkeletonCard: React.FC<{ className?: string }> = ({ className }) => (
  <div className={cn("p-4 border rounded-lg", className)}>
    <Skeleton className="h-6 w-3/4 mb-2" />
    <SkeletonText lines={2} />
  </div>
);

const SkeletonChatMessage: React.FC<{ className?: string }> = ({ className }) => (
  <div className={cn("flex gap-4 p-4", className)}>
    <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
    <div className="flex-1 space-y-2">
      <Skeleton className="h-4 w-20" />
      <SkeletonText lines={3} />
    </div>
  </div>
);

const SkeletonFileItem: React.FC<{ className?: string }> = ({ className }) => (
  <div className={cn("flex items-center gap-3 p-2", className)}>
    <Skeleton className="w-4 h-4" />
    <Skeleton className="h-4 flex-1" />
  </div>
);

const SkeletonDashboardCard: React.FC<{ className?: string }> = ({ className }) => (
  <div className={cn("p-6 border rounded-lg", className)}>
    <Skeleton className="h-6 w-24 mb-4" />
    <Skeleton className="h-8 w-16 mb-2" />
    <Skeleton className="h-4 w-32" />
  </div>
);

export {
  Skeleton,
  SkeletonText,
  SkeletonCard,
  SkeletonChatMessage,
  SkeletonFileItem,
  SkeletonDashboardCard
};